/**
 * Intentional actions of all the modules
 * Taken reference from https://microsoft.sharepoint-df.com/:x:/t/CTGAIN/EQtJ3wkvDVdGu1-Nj5VMxYgBz3OFaiFVW3Zk1hz35Cjd6Q?e=ir2jXc
 * Please update the list here if anything changes in the document mentioned above
 * The names mentioned in the comments for each line are the original events which are mentioned in the excel sheet
 * We are using the names which the code base uses internally
 */
export const intentionalActions = {
    mail: [
        'ComposeMailSent', // MailComposeSend
        'ComposeEmailClicked', // MailComposeNew
        'ReplyEmailClicked', // MailComposeReply, MailComposeReplyAll
        'ForwardEmailClicked', // MailComposeForward
        'singleSelectMailItem', // LoadMailConversation
        'FocusedOtherTabClicked', // FocusedPivotClick
        'selectFolder', // SelectFolder
        'markSelectedItemsReadState', // TnS_MarkSelectedConversationsReadUnread
        'markItemsAsRead', // markItemAsRead/Unread
        'markConversationAsRead', // TnS_MarkConversationRead
        'moveSelectedItems', // TnS_MoveSelectedConversations
        'moveItem', // TnS_MoveConversation
        'moveItemToFocusedOrOther', // TnS_MoveConversationToFocusedOrOther
        'applySelectedItemsFlaggedState', // TnS_FlagSelectedConversation
        'applyItemFlaggedState', // TnS_FlagConversation
        'deleteSelectedItems', // TnS_DeleteSelectedConversations
        'deleteConversation', // TnS_DeleteConversation
        'deleteItemFromReadingPane', // TnS_DeleteItem
        'deleteItemsWithoutConfirmDialog', // TnS_DeleteItem
    ],
    calendar: [
        'SaveCalendarEvent',
        // LoadCalendarModuleE2E is taken care of in postCalendarBootstrap
        'meetingMessageAction',
        'ViewButtonClicked', // ViewCalendarEvent
        'EventClicked', // ViewCalendarEvent
        'SwitchCalendarView',
        'DeleteEvent',
    ],
    people: [
        'CreateContactComplete',
        'AddContactComplete',
        'setPeopleCardRoute', // LaunchPeopleCard
        // PeopleHubInitialRenderComplete is taken care of in postPeopleBootstrap
        'SaveEditsComplete',
        'QuerySubmitted', // WF_SubmitUnifiedSearch
        'KeyWordSelected', // WF_SubmitUnifiedSearch
        'ContactSelected', // WF_SubmitUnifiedSearch
        'SwitchSearchTab', // WF_SubmitUnifiedSearch
        'DeleteContactComplete',
    ],
    search: [
        'QuerySubmitted', // WF_SubmitUnifiedSearch
        'KeyWordSelected', // WF_SubmitUnifiedSearch
        'ContactSelected', // WF_SubmitUnifiedSearch
        'SwitchSearchTab', // WF_SubmitUnifiedSearch
    ],
    file: [
        'BeginFileAttachment', // AttachmentCreation
        'forwardAttachmentFromPreview', // AttachmenetPreviewAction
        'previewAttachment', // PreviewAttachment
    ],
};
